import { DetailsContainer } from './DetailsContainer';

const WorkAndExperience = ({ heading, data, color }) => {
  return (
    <div className="flex flex-col mb-7 mt-7">
      <h3 className="text-3xl font-semibold mb-5">{heading}</h3>
      {data.map((d) => (
        <div key={d.id} className="pl-14 relative mb-5">
          <DetailsContainer
            key={d.experience_id}
            title={d.role}
            subtitle={d.company_name}
            startDate={d.start_date}
            endDate={d.end_date}
            summary={d.summary}
            color={color}
            current={d.current}
          />
        </div>
      ))}
    </div>
  );
};

export default WorkAndExperience;
